import React from 'react'
import { formatDateStandard } from '../../../global/formatters/string-formatter'
import Tooltip from '../../Tooltip/Tooltip.jsx'

function TableUtility({ data, toolTips }) {
  const { fields, keyId, selector, sorting, sortClick, type, values } = data
  const defaultTableClass = 'Table Table--reversed Table--striped'

  function getSortOrder(selectedSortField) {
    const { sortOrder, sortField } = sorting

    return sortField === selectedSortField ? sortOrder : ''
  }

  function getSortIcon(selectedSortField) {
    const { sortOrder, sortField } = sorting
    const iconStyle = 'Icon Icon--cti u-textSizeMsrm2'

    if (sortField === selectedSortField) {
      return sortOrder === 'asc' ? (
        <span className={`${iconStyle} sorting_asc`} aria-hidden="true">
          
        </span>
      ) : (
        <span className={`${iconStyle} sorting_desc`} aria-hidden="true">
          
        </span>
      )
    }

    return null
  }

  return (
    <table
      id={`sub-table-${type}`}
      key={keyId}
      className={`${defaultTableClass} ${selector}`}
    >
      <thead className="Table-head">
        <tr className="Table-row">
          {fields.map((field, index) => {
            const sortField = field.name
            const filteredTip = toolTips?.filter((tip) => tip.id === sortField)

            if (filteredTip?.length > 0) {
              return (
                <th
                  className="Table-header cti-col-hdr Table-util-tooltip-header u-posRelative"
                  key={`${keyId}-th-${index}`}
                  data-type={type}
                >
                  <Tooltip
                    content={filteredTip[0].content}
                    heading={filteredTip[0].heading}
                    id={filteredTip[0].id}
                    direction={filteredTip[0].direction}
                  >
                    <span
                      className={`u-textSecondary Tooltip-label ${
                        filteredTip[0].skipHoverBrandLight
                          ? 'no-hover-brand-light'
                          : ''
                      }`}
                    >
                      {field.header}
                    </span>
                    <span
                      className={`Icon--material Tooltip-icon u-marginLeft1gu ${
                        filteredTip[0].skipHoverBrandLight
                          ? 'no-hover-brand-light'
                          : ''
                      }`}
                    >
                      info
                    </span>
                  </Tooltip>
                </th>
              )
            } else {
              return (
                <th
                  className="Table-header cti-col-hdr"
                  key={`${keyId}-th-${index}`}
                  onClick={sortClick}
                  data-type={type}
                  data-sort-field={sortField}
                  data-sort-order={getSortOrder(sortField)}
                >
                  {field.header} {getSortIcon(sortField)}
                </th>
              )
            }
          })}
        </tr>
      </thead>
      <tbody>
        {values.map((row, index) => {
          return (
            <tr className="Table-row" key={`${keyId}-tr-${index}`}>
              {fields.map((field, subIndex) => {
                let display = row[field.name]

                if (field.type === 'date') {
                  display = formatDateStandard(display)
                }

                return (
                  <td className="u-padding2gu" key={`${keyId}-td-${subIndex}`}>
                    {display}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default TableUtility
